<script setup lang="ts">
import Dialog from '@/components/ui/dialog/Dialog.vue'
import DialogContent from '@/components/ui/dialog/DialogContent.vue'
import DialogHeader from '@/components/ui/dialog/DialogHeader.vue'
import DialogTitle from '@/components/ui/dialog/DialogTitle.vue'
import DialogFooter from '@/components/ui/dialog/DialogFooter.vue'
import { usePaywallStore } from './usePaywallStore'
import { Button } from '@/components/ui/button'
import { useTranslateKey } from '@/lib/utils'

const { translateKey } = useTranslateKey()

const paywallStore = usePaywallStore()
</script>
<template>
  <Dialog v-model:open="paywallStore.isPaywall">
    <DialogContent>
      <DialogHeader>
        <DialogTitle>{{ translateKey('unlockFeature') }}</DialogTitle>
      </DialogHeader>
      <div>
        {{ translateKey('featureNotAvailable') }}
      </div>
      <DialogFooter>
        <Button @click="paywallStore.redirectContactOrStripe">
          {{ translateKey('tryNow') }}
        </Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
</template>
